import privacyPageText from "./privacy";
import { MAX_LISTING_PHOTOS } from "./listing-photos";
import { PROHIBITED_ITEMS } from "./prohibited-items";

/**
 * Alias kept so the sell UI reads in its own vocabulary; the number itself lives in
 * one place. The copy strings below are generated from it, because they had already
 * drifted — they promised "Max 12" while the uploader cut off at a hardcoded 8.
 */
export const MAX_SELL_IMAGES = MAX_LISTING_PHOTOS;

export default {
  appTitle: "Sellwild Marketplace",
  appDescription: "Listings viewed by millions every day",
  appMetaImage: "/logo-sellwild.png",
  appMetaImageAlt: "Sellwild Marketplace Logo",
  notices: {
    stripeConnectNotice: `Please Connect with Stripe to get Paid!`,
    youAreSellerNotice: "As Seller, You can't start a chat on your own Listing",
    cantFindChatNotice: "We can't find that Chat anymore. Maybe it was deleted",
    newChatMsgNotice1: "You have",
    newChatMsgNotice2: "New chat message",
    purchaseUpdateNotice: "Update on Your Purchase with",
    saleUpdateNotice: "Update on Your Sale with",
    successMsgDeleteNotice: "Message Deleted",
    successChatDeleteNotice: "Chat Thread Deleted",
  },
  nav: [
    {
      link: "/",
      label: "All",
    },
    {
      link: "/browse/auto/",
      label: "Auto",
    },
    {
      link: "/browse/jewelry/",
      label: "Jewelry",
    },
    {
      link: "/browse/jobs/",
      label: "Jobs",
    },
    {
      link: "/browse/electronics/",
      label: "Electronics",
    },
    {
      link: "/browse/fashion/",
      label: "Fashion",
    },
    {
      link: "/browse/pets/",
      label: "Pets",
    },
  ],
  top: {
    placeholderLabel: "Search Sellwild",
  },
  footer: {
    copyright: `&copy; ${new Date().getFullYear()} Antengo, Inc`,
  },
  chat: {
    chatLabel: "Reply",
    newLabel: "New",
    youMsgLast: "You sent:",
    theyMsgLast: "sent:",
    buttonLabel: "Send Message",
    buyerInputPlaceholder: "Ask about this listing",
    sellerInputPlaceholder: "You are the seller",
    sellerChatWarning: "Note: Unverifed User. Please Use Caution",
  },
  browse: {
    shortsHeading: "Sellwild Shorts",
    shortsHeadingLink: "Get paid for your video review",
    homepageTitle:
      "Sellwild Marketplace: Listings viewed by millions every day",
    pageTitle: "Browse Sellwild",
    endlessScrollHeading: "Latest Listings",
    filteredListingsHeading: "Filtered Listings",
    sellwildTVHeading: "Introducing Sellwild TV!",
    doneListingLabel: "That's all folks!",
    categoryHeading: "Browse ",
    noResultsHeading: "Nothing found for:",
    noResultsHeading2: "Here is the latest ",
    resultsHeading: "What we found for:",
    metaDescription: "Listings views by millions everyday",
    loadMoreLabel: "Load More",
    loadingLabel: "Loading...",
    localSwitchLabel: "By Distance",
    closeLocalLabel: "Close",
    backToTopLabel: "Back to Top",
  },
  about: {
    pageTitle: "About Sellwild",
    tagLine: "Listings viewed by millions every day",
    content:
      "<p>At Sellwild, we’re on a mission to allow buyers to find the new and used items that they are looking for, allowing for product discovery and delight at a good deal.  We take pride in having seller’s listings being discoverable across the internet on relevant, specifically targeted publisher sites.  Our listings can be viewed by millions every day across automotive sites like Motor1, fashion and beauty sites like SheFinds, tech sites like Boing Boing, and local interest news sites like the Miami New Times, WRAL, and Times of Israel.</p><p>On Sellwild, you can buy or sell cars, electronics, apparel and more. Sellwild is a trusted marketplace with buyer guarantees and verified sellers. Listings are viewed by millions every day.</p><p>We were founded in 2011, and since then, we’ve been innovating in the online commerce space, with unique products and commerce solutions for buyers and sellers; content creators and advertisers.  With our mini-marketplace widget, we syndicate our featured listings to the right location where interested users regularly do their research on the top products within that category.  By meeting potential buyers and sellers where they already are, we help facilitate an eCommerce transaction quickly and effectively.</p>",
  },
  investors: {
    pageTitle: "Investors",
    content:
      '<p>Antengo, doing business as Sellwild, is funded by Verizon, has raised NRE capital from Samsung, and continues to raise additional capital. If you’re interested in investing by joining our latest capital fundraise, feel free to contact us at <a href="mailto:investors@sellwild.com">investors@sellwild.com</a>.</p><p>We’ve been innovating in the world of classified ads, media publishing and eCommerce for over a decade, while our team’s collective experience in the space spans centuries. Our team also consists of product, eCommerce, advertising & digital media leaders that previously held management roles at companies such as Microsoft, Facebook, Best Buy and Outbrain, to name a few.</p><p>The remote team is spread out globally, with about half of the team centered in the Pacific Northwest, California and Nevada, and the other half of the team spread across locations including the Northeast US, Southeast US, and internationally in countries across Europe and the Middle East.</p>',
  },
  partners: {
    pageTitle: "Partners",
    tagLine: "Listings viewed by millions every day across sites like",
    partnerQuoteHeading: "So, how's it going...",
    testimonialHeading: "<p><u>Case Study</u><br/>Motorsport Network</p>",
    testimonials: [
      {
        intro: `
				<p><a href="https://www.motorsportnetwork.com" target="blank" rel="noreferrer noopener">Motorsport Network</a>, the largest global network of online automotive media brands, has partnered closely with the Sellwild Marketplace for Publishers since Sellwild’s inception in late 2019.</p>
				<p>Motorsport Network is the leading independent voice of the motorsport and automotive industries and their fans.</p>
				<p>Since its foundation in 2015, it has become a global market leader in media and technology in this sector, making connections among the millions of passionate racing and automotive fans with a network of industry players and stakeholders.</p>
				<p>Motorsport Networks brands include Motor1, InsideEVs, Ferrari Chat, RideApart, and more.</p>`,
        quote: `<quote><p><b>Sellwild’s commerce + contextual ads product has grown 3rd party monetization by ~20% since we launched with them.  Motorsport has already earned over seven figures from Sellwild’s unique approach to eCommerce listings + ads.</b></p>
				<p>Over the years, we have tested countless 3rd party advertising widgets and integrations.  Unlike other products that may require a publisher to sacrifice user experience in return for meaningful revenue returns, the Sellwild Marketplace has consistently driven incredible incremental revenue for our brands while maintaining a tasteful look and feel that’s native to our premium automotive and motorsport brands.
				<p>Their product is also an enhancement to the user experience with relevant vehicles for sale and some good-looking images of those vehicles to boot.</p>
				<p>On top of Sellwild enhancing our brands by giving us our own marketplace, Sellwild’s team is also enjoyable to work with, responsive to all of our needs, and eager to help us constantly improve our website monetization in any way possible.</p>
				<p>They also pay on time, every month, don’t pass along ad serving fees, 3rd party service fees (such as costs like blocking bad ads / malvertising), or any other fees.</p>
				<p>Sellwild has proven over the years to keep our bottom line financial interests at the forefront of our partnership with them.</p></quote>
			`,
        image: `/images/headshots/louis.jpeg`,
        byLine: `
				<p>- Louis Giocondo<br/>
				SVP Sales, Americas<br/>
				Motorsport Network</p>
			`,
      },
    ],
    featuredPartners: [
      {
        name: "Graham Media Group",
        href: "https://www.grahammedia.com/",
        img: "/images/partner-logos/Graham_Media_Group_logo.png",
      },
      {
        name: "Genius",
        href: "https://genius.com",
        img: "/images/partner-logos/genius-logo-transparent.png",
      },
      {
        name: "Car Scoops",
        href: "https://www.carscoops.com/",
        img: "/images/partner-logos/carscoops-logo.png",
      },
      // {
      //   name: "Spin",
      //   href: "https://spin.com",
      //   img: "/images/partner-logos/partner-spin.jpg",
      // },
      {
        name: "Shefinds",
        href: "https://shefinds.com",
        img: "/images/partner-logos/partner-shefinds.jpg",
      },
      // {
      //   name: "WRAL News",
      //   href: "https://wral.com",
      //   img: "/images/partner-logos/partner-wral.jpg",
      // },
      // {
      // 	name: "Shaw Local News Network",
      //     href: "https://www.shawlocal.com/",
      //     img: "/images/partner-logos/partner-shaw.jpg"
      // },
      // {
      // 	name: "Inside EVs",
      //     href: "https://insideevs.com",
      //     img: "/images/partner-logos/partner-insideevs.jpg"
      // },
      // {
      // 	name: "Whats My IP",
      //     href: "https://whatsmyip.com",
      //     img: "/images/partner-logos/partner-whatsmyip.jpg"
      // },
      // {
      //   name: "Boing Boing",
      //   href: "https://boingboing.net",
      //   img: "/images/partner-logos/partner-boing-boing.jpg",
      // },
      // {
      //   name: "Motor1",
      //   href: "https://motor1.com",
      //   img: "/images/partner-logos/partner-motor1.jpg",
      // },
    ],
  },
  login: {
    privacyLink: "Privacy and Terms of Service",
    gotoPrivacy: "View our",
    oldTokenMsg: "Your session has expired. Please login again.",
    createAccountToo: "Create an Account Automatically",
    googleErrorMsg1:
      "Google Email found! Please connect to Sellwild with your phone number",
    googleSuccessMsg1:
      "Google Signed in! Please connect to Sellwild with a phone number",
    appleErrorMsg1: "Apple not returning any data.  Can't use Apple to Signup",
    appleErrorMsg2:
      "Apple Email found! Please connect to Sellwild with your phone number",
    appleErrorMsg3: "Apple authentication error",
    appleSuccessMsg1:
      "Apple Signed in! Please connect to Sellwild with a phone number",
    emailFoundMsg:
      "Email Address found. Please connect to Sellwild using your phone number",
    emailTakenMsg:
      "That email is taken. Is it yours? Sign in with a code sent to it instead.",
    fbUserCancelMsg: "User cancelled login or did not fully authorize",
    fbSuccessMsg1: "Facebook Authorized! Please connect to Sellwild",
    proceedLabel: "Click to Proceed",
    loginSignupButtonLabel: "Signup",
    loginHeading: "to Sellwild!",
    loginSubHeading: "Login or Create an Account",
    verifyHeading1: "We just texted you",
    verifyHeading1b: "We just e-mailed you",
    verifyHeading2: "A 6-digit number",
    verifySub: "It's valid for the next 15 minutes",
    verifySub2: "Please Enter it Here",
    moreInfoHeading: "We need a little more info to finish up!",
    twoFactorHeading1: "Protect your account",
    twoFactorHeading2: "With 2-Factor Auth",
    nameLabel: "Name",
    phoneEmailLabel: "Phone or Email",
    // phoneEmailLabel: "Email Address",
    phoneLabel: "Mobile",
    phoneEmptyErrorMessage: "Start here!",
    phoneInvalidErrorMessage: "Phone number must be 10 digits",
    emailLabel: "Email Address",
    emailOptionalLabel: "Email Address (optional)",
    emailTakenErrorMessage: `This Email is taken.`,
    emailEmptyErrorMessage: "Email address please",
    nameInvalidErrorMessage: "Your name, please",
    nameShortErrorMessage: "Your name, please",
    lastNameNeededErrorMessage:
      "Last name please. It's never shown publically.",
    emailInvalidErrorMessage: "Strange lookin email ya got there",
    mobileLabel: "Mobile Number",
    continueButtonLabel: "Continue",
    verifyButtonLabel: "Verify",
    verifyingButtonLabel: "Checking...",
    submittingLabel: "One moment...",
    socialSignupLabel: "or sign up with",
    tryAgainLabel: "Try Again",
    gotoSignupLabel: "",
    gotoLoginLabel: "Already have an account?",
    gotoPasswordlessLoginLabel: "Login without a password?",
    loginWord: "Login",
    signupWord: "Welcome",
    loginLink: "Login",
    signupLink: "Password-free Login",
    orSignupLabel: "or sign up with",
    orLoginLabel: "or sign up with",
    tagLine: "Listings viewed by millions every day",
    resendPassword: "Send a new code",
    resendSendingLabel: "Sending...",
    resendSentLabel: "New code sent",
    useDifferentLoginLabel: "Use a different number or email",
    phoneVerified: "Phone Number Verified",
    welcomeLoggedIn: "You're Logged In!",
    addressDuplicateErrorMessage: "This address is already saved",
    welcomeSignup: "Welcome to the Jungle!",
    recaptchaCompliance: "This site is protected by reCAPTCHA and the Google",
    otpFailed: "Sorry, that was not the correct digits",
    otpWrongCode: "That code isn't right. Check it and try again.",
    phoneSignupNeedsEmail: "Your number is confirmed. Now enter your email to finish. If you sell through Vendoo, use your Vendoo email.",
    otpExpiredCode: "That code has expired. Send a new code.",
    otpNetworkError: "We couldn't check that code. Try again.",
  },
  notifications: {
    header: "Notifications",
    noNotificationsCTAHeading: "None, Yet...",
    noNotificationsCTAExplain: "You're Inbox is Empty",
    noNotificationsCTAButton: "Shop or Sell",
  },
  product: {
    promo50: "$50 Bonus for 1st Sale!",
    verifiedSellerLabel: "Verified Seller",
    moreLabel: "Read More",
    feesMayApply: "Adoption Fee",
    nextButtonLabel: "Go to Next Listing",
    prevButtonLabel: "Go to Previous Listing",
    moreOnAdoption: "More About Adoption",
    clickForFees: "Fees May Apply",
    fullDescriptionHeading: "Full Description",
    emailSubject: "Inquiry from SELLWILD Re: ",
    GCCIntro: `Dear Gateway Classic Cars, \n\nI found this listing on Sellwild and am interested in learning more.  Could we please setup a phone call or appointment for me to view?\n\nThanks!\n\n-----\n\n For internal use, for a prompt response do not remove\n`,
    MYEVIntro: `Dear MyEV, \n\nI found this listing on Sellwild and am interested in learning more.  Could we please setup a phone call or appointment for me to view?\n\nThanks!\n\n-----\n\n For internal use, for a prompt response do not remove\n`,
    GCC_ID: 74569925,
    MYEV_ID: 94977342,
    GCC_DATASOURCE: 27,
    MYEV_DATASOURCE: 28,
    RESCUEGROUPS_DATASOURCE: 30,
    LOTLINX_DATASOURCE: 31,
    AMAZON_DATASOURCE: 32,
    BARGAINHUNTER_DATASOURCE: 33,
    SPORTSERVER_DATASOURCE: 35,
    emailPreferred:
      "Heads up that this seller prefers Email communication.  So, we're routing you to your Email client with a message pre-populated in an email to this seller (ready for you to hit send)",
    stripeFeeLabel: "Stripe",
    stripeFeeTooltip: "Stripe Credit Card Fee (2.9% + $0.30)",
    unavailableSign: "Sold",
    pendingSaleSign: "Sale Pending",
    clickToChatLabel: "Contact Seller",
    cancelLabel: "Cancel",
    profilePhotoAlt: "Seller's Profile Photo",
    emailOnlyLabel: "Contact Seller",
    requestingLabel: "Requesting...",
    editProductLabel: "Edit Listing",
    buyButtonLabel: "Buy Now",
    chatLabel: "Chat with Seller",
    contactShelterLabel: "Contact Shelter",
    openRemoteUrlLabel: "Go to Seller's Site",
    viewDealLabel: "View Deal",
    partnerNames: {
      27: "Gateway Classic Cars",
      31: "the dealer",
      32: "Amazon",
      33: "Amazon",
      35: "SportServer",
    } as Record<number, string>,
    viewDealSoldByLabel: "Sold by",
    viewDealOpensInNewTab: "Opens in a new tab",
    viewDealTrustNote: "{partnerCap} is a Trusted Sellwild Partner. Sellwild is an affiliate. Shipping will be arranged through {partner}.",
    viewDealTrustNoteCars: "{partnerCap} is a Trusted Sellwild Partner. Sellwild is an affiliate. Shipping will be arranged if needed through {partner}.",
    contactHowItWorksHeading: "How it works",
    contactStepChat1: "Start a conversation",
    contactStepChat2: "Ask questions, negotiate",
    contactStepChat3: "Arrange pickup or shipping",
    contactStepEmail1: "Send an email to the seller",
    contactStepEmail2: "Ask questions, negotiate",
    contactStepEmail3: "Arrange pickup or shipping",
    secureMessagingHeading: "Secure Messaging",
    secureMessagingText: "Messages stay on Sellwild.",
    emailPreferredHeading: "Email Preferred",
    adoptionHowItWorksHeading: "How adoption works",
    adoptionStep1: "Contact the shelter directly",
    adoptionStep2: "Complete their application",
    adoptionStep3: "Meet your new companion",
    adoptionFeeNote: "Adoption fees support the rescue — paid directly to the shelter.",
    adoptionBuyerProtectionText: "Sellwild lists adoptions without compensation.",
    partnerBuyerProtectionText: "Offsite partners have their own guarantees.",
    contactShelterHeading: "Contact Shelter Directly",
    escrowLabel1: "We use",
    escrowLabel2: "for Secure Payment",
    yourListingHeading: "Your Listing",
    // Under the shipping line on a seller's own listing. That quote is to the
    // seller's own area, so it says it is a sample rather than what buyers pay.
    ownerShippingSampleNote: "Sample to your area. Each buyer pays shipping to their address.",
    moreLabel1: "Similar Listings",
    moreLabel2: "(Don't miss 'em!)",
    otherLabel: "More from",
    descLabel: "Description",
    setupStripeButtonLabel: "Get Your Earnings",
    postedByLabel: "Listed By",
    manageTransactionsLabel: "Manage Sales",
    orderDetailsHeading: "Purchase Details",
    adoptionDetailsHeading: "Adoption details",
    tax: "Tax",
    // The product page's tax line is the table's state-level estimate for the
    // visitor's location; checkout quotes it again for the real address.
    salesTaxEstimateLabel: "Est. tax",
    subtotal: "Price",
    totalDue: "Total",
    // What the shipping line says while a rate is in flight. The same sentence
    // checkout uses (`checkout.estimateCalculating`), because it is the same
    // wait: the buy box used to say "Wait for it", which asks the reader for
    // patience without telling them what for, and reads as a tease on the one
    // line of the box that is genuinely still unknown.
    shippingCalculating: "Calculating...",
    // What the Total says while that rate is in flight. A sum with an unknown
    // term in it has no number yet, and an em dash says so in the width of one
    // — a second copy of "Calculating..." on the bold total line only repeated
    // the shipping row and pushed the row it belongs to out of shape.
    totalPending: "—",
    favoriteLabel: "Favorite this Product",
    shareLabel: "Share on Facebook",
    interestedLabel: "Buy Now",
    marketplaceLabel: "Shop",
    sellProductLabel: "Sell",
    watchTooltip: "Watch Item",
    flagTooltip: "Report",
    manageTooltip: "Manage Listing",
    shareTooltip: "Share",
    verified: "Verified",
    verifiedTooltip: "Trusted Seller",
    verifiedTooltip2: "",
    chatTooltip: "Secure Chat",
    reportError: `Can't Report this Listing`,
    reportedNotification1: "We got your Report",
    reportedNotification2: "Thanks!",
  },
  /**
   * The ellipsis menu a seller gets on their OWN listing, in place of the report
   * menu. Sellers were reporting their own items because Report was the only
   * control the product page offered them.
   */
  ownerMenu: {
    ariaLabel: "Manage this listing",
    manageListingLabel: "Manage Listing",
    markSoldLabel: "Mark Sold",
    editLabel: "Edit",
    delistLabel: "Delist",
    relistLabel: "Relist",
    manageOrdersLabel: "Manage Orders",
    workingLabel: "Working\u2026",
    markSoldSuccess: "Marked sold. Buyers can no longer buy it.",
    markSoldError: "Couldn't mark this listing sold. Nothing was changed.",
    delistSuccess: "Delisted. Buyers can no longer find it.",
    delistError: "Couldn't delist this listing. Nothing was changed.",
    relistSuccess: "Relisted. Buyers can find it again.",
    relistError: "Couldn't relist this listing. Nothing was changed.",
    staleStatusError: "This listing's status changed since the page loaded. Reload to see where it stands.",
    notYoursError: "This listing is no longer yours to manage.",
  },
  submenus: {
    facebookLabel: "Facebook",
    twitterLabel: "Twitter/X",
    copyLinkLabel: "Copy Link",
    copiedLabel: "Copied to Clipboard",
    emailLabel: "Email",
    // One report action per row, each naming what it reports. The menu used to
    // open with a bare "Report" above "Spam", and nobody could tell what the
    // first one did that the other three did not.
    reportSpamLabel: "Report Spam",
    otherLabel: "Other",
    inappropriateLabel: "Inappropriate",
    deleteMessageLabel: "Delete Message",
    deleteChatLabel: "Delete Conversation",
    copyMessageLabel: "Copy Message",
    copyChatLabel: "Copy Whole Thread",
    viewMessagesLabel: "View Messages",
    blockUserLabel: "Block User",
    unblockUserLabel: "Unblock User",
    reportUserLabel: "Report User",
    clipboardAccessDeniedNotice:
      "Access to the clipboard was denied by this browser.  Please update in Settings.",
  },
  /** The free-text step behind the report menu's "Other". */
  reportOther: {
    popupHeading: "Tell us what's wrong",
    popupExplain: "Your message goes to the Sellwild team with a link to this listing.",
    placeholder: "What's the problem with this listing?",
    submitLabel: "Send Report",
    cancelLabel: "Nevermind",
  },
  userReport: {
    popupTitle: "Report User",
    popupPlaceholder: "Please describe the issue...",
    confirmButton: "Report and Block",
    cancelButton: "Cancel",
    userBlockedNotice: "User has been blocked",
    userUnblockedNotice: "User has been unblocked",
    userReportedNotice: "User has been reported and blocked",
    reportError: "Failed to report user. Please try again.",
    blockError: "Failed to block user. Please try again.",
    unblockError: "Failed to unblock user. Please try again.",
  },
  learnMore: {
    pageTitle: "Sell Your Stuff - Learn More",
    metaDescription:
      "With exposure across the internet on sites like Motor1.com; Spin.com and BoingBoing.net, Sellwild listings reach millions of unique users a day. Our unique mini-marketplace widget allows for the right types of products to show up alongside relevant content that our publishers create",
    shopNowButton: "Shop Now",
    learnMoreButton: "Learn More",
    startSellingButton: "Start Selling",
    whyShouldHeading: "Why you should...",
    whySellHeading: "Sell On Sellwild",
    whyBuyHeading: "Buy On Sellwild",

    whyBuy1Heading: "Trust",
    whyBuy1Description:
      "Buyers can rest easy knowing that Sellwild is a trusted marketplace, purchasing products from verified sellers, with a buyer guarantee",
    whyBuy1Icon: "trust-icon.svg",
    whyBuy2Heading: "Variety",
    whyBuy2Description:
      "With new listings everyday, across a variety of categories, from electronics to auto, fashion to home items, Sellwild has what you are looking for",
    whyBuy2Icon: "variety-icon.svg",
    whyBuy3Heading: "Connection",
    whyBuy3Description:
      "On Sellwild, we provide a direct line of communication with Sellers. It's simple as sending a quick text chat if you have any questions before or after purchasing",
    whyBuy3Icon: "connection-icon.svg",

    whySell1Heading: "Reach",
    whySell1Description:
      "With exposure across the internet on sites like Motor1.com; Spin.com and BoingBoing.net, Sellwild listings reach millions of unique users a day. Our unique mini-marketplace widget allows for the right types of products to show up alongside relevant content that our publishers create",
    whySell1Icon: "reach-icon.svg",
    whySell2Heading: "Simplicity",
    whySell2Description:
      "With Sellwild's simple Post a Listing flow, you can post multiple products in the time it takes you to take a few quick photos. Adding the product title, price and a quick description, and the product is live",
    whySell2Icon: "simplicity-icon.svg",
    whySell3Heading: "Profit",
    whySell3Description:
      "With Sellwild, pricing is transparent, with tax and shipping calculated for you allowing for you to keep your earnings in your pocket. A platform flat fee of 10% is deducted from the seller to list, while the Buyer pays for the item, shipping, tax and a 2.9% credit card transaction fee",
    whySell3Icon: "profit-icon.svg",

    automotiveHeading: "Automotive",
    automotiveDescription:
      "From electrics vehicles to classic cars, Sellwild has the drive to help you find your next hot ride. Unleash your need for speed with the latest and greatest, one of a kind vehicles in Automotive now",
    automotiveButton: "Shop Automotive",

    uniqueHeading: "Looking for something unique?",
    viewMoreButton: "View more",
    whatSoldButton: "See what's sold",
    learnMoreHeading: "Want to learn more?",
    learnMoreDescription: "Check out our answers to frequently asked questions",
    faqButton: "View FAQ’s",
    termsButton: "View Terms and Conditions",

    mainHeading: "Pics. Post. Ship. Get Paid.",
    jumbotron:
      "Your item will receive millions of monthly views across our publisher sites in a few simple steps.",

    tabs: [
      {
        name: "Why Sell On Sellwild?",
        image: "/images/animals/panda-full.png",
        content: [
          {
            heading: "Reach",
            description:
              "With exposure across the internet on sites like Motor1.com; Spin.com and BoingBoing.net, Sellwild listings reach millions of unique users a day. Our unique mini-marketplace widget allows for the right types of products to show up alongside relevant content that our publishers create.",
            icon: "/images/svg/reach-icon.svg",
          },
          {
            heading: "Simplicity",
            description:
              "With Sellwild's simple Post a Listing flow, you can post multiple products in the time it takes you to take a few quick photos. Adding the product title, price and a quick description, and the product is live.",
            icon: "/images/svg/simplicity-icon.svg",
          },
          {
            heading: "Profit",
            description:
              "With Sellwild, pricing is transparent, with tax and shipping calculated for you allowing for you to keep your earnings in your pocket. A platform flat fee of 10% is deducted from the seller to list, while the Buyer pays for the item, shipping, tax and a 2.9% credit card transaction fee.",
            icon: "/images/svg/profit-icon.svg",
          },
        ],
      },
      {
        name: "Why Buy On Sellwild?",
        image: "/images/animals/bear-full.png",
        content: [
          {
            heading: "Trust",
            description:
              "Buyers can rest easy knowing that Sellwild is a trusted marketplace, purchasing products from verified sellers, with a buyer guarantee.",
            icon: "/images/svg/trust-icon.svg",
          },
          {
            heading: "Variety",
            description:
              "With new listings everyday, across a variety of categories, from electronics to auto, fashion to home items, Sellwild has what you are looking for.",
            icon: "/images/svg/variety-icon.svg",
          },
          {
            heading: "Connection",
            description:
              "On Sellwild, we provide a direct line of communication with Sellers. It's simple as sending a quick text chat if you have any questions before or after purchasing.",
            icon: "/images/svg/connection-icon.svg",
          },
        ],
      },
    ],
  },
  post: {
    // A listing held for admin review (utils/listing-review.ts): its text has a
    // phone number, a WhatsApp or Telegram contact, or a supplier pitch.
    underReviewMessage:
      "Your listing is under review. We check listings that include a phone number or an outside contact before they go live. It goes on sale once we approve it.",
    underReviewTag: "Under review",
    underReviewHint: "We check listings with a phone number or an outside contact before they go live.",
    rejectedTag: "Not approved",
    rejectedHint: "This listing was not approved. Buyers pay and message through Sellwild, so listings cannot carry a phone number or an outside contact.",
    vinLabel: "Vehicle Identification Number",
    mileageLabel: "Mileage",
    changeAddress: "Change Address",
    spinner1: "Images Uploading",
    spinner2: "One moment please",
    postFAQHeading: "Frequently Asked Questions",
    vechicleVariantsHeading: "Vehicle Information",
    mileageShortErrorMessage: "Current mileage reading, please",
    vinEmptyErrorMessage: "Vehicle Identification Number, please",
    vinShortErrorMessage: "VIN is too short.",
    vinInvalidErrorMessage: "VIN is invalid.",
    shippingPopupHeading: "One Last Step!",
    shippingPopupHeading2:
      "Get in front of more buyers by shipping nationally.",
    shippingPopupHeading3:
      "We Negotiate the Cheapest rates. The Buyer pays for Shipping.",
    shippingMaxLengthErrorMessage: "108 inches max",
    addShippingLabel: "Add Shipping",
    localOnlyLabel: "Local Only",
    unloadConfirmMessage: "Leave now? Photos are still uploading.",
    uploadFinishedMsg: "Photos Uploaded",
    promoLabel: "BONUS",
    promoTitle: "Make 50 Extra Bucks on your First Sale!",
    promoTermsConditions: "Terms and Conditions",
    shippingAddressNeededMessage: "Quickly Search for Your Address",
    cannotGeoCodeError: "Cannot geocode that address, please add more info.",
    scroll4more: "Scroll for more",
    unexpectedError:
      "Unexpected Empty Server Response. Please try Saving Again.  Thanks",
    cameraSystemError: `Camera Access may be Denied in your Phone's Settings. Please Change to Allow.`,
    categoryPopupHeader: "Pick a Category",
    notShippableLabel: "Not Shippable",
    addAddressLabel: "Add Shipping Address",
    shippableLabel: "Can Be Shipped",
    localPickupOnlyLabel: "Local Pickup Only",
    needsAddressHeading: "Add a Shipping From Address",
    needsCityHeading: "Where is the Item Located?",
    hasCityHeading: "Item Location",
    changeLocalLink: "Change Location",
    needsCitySubheading: "Only City, State Appear on the Listing",
    shippingHeading: "Item Shipping",
    vehicleShippingHeading: "Vehicle Shipping",
    markProductSoldLabel: "Mark Sold",
    confirmMarkSoldHeading: "Mark Sold?",
    confirmMarkSoldExplain: "Are you sure you want to mark item sold?",
    confirmRemovalHeading: "Delete Listing?",
    confirmRemovalExplain: "Are you sure you want to remove this listing?",
    confirmRemovePhotoHeading: "Delete Photo?",
    confirmRemovePhotoExplain: "Are you sure you want to remove this photo?",
    cancelButtonLabel: "Cancel",
    removeSuccessMsg: "Listing Deleted",
    markSoldSuccessMsg: "Listing Marked Sold",
    notShippableCatHeading: "This Category is Not Shippable",
    needsAddressSubheading:
      "Never shown or shared. Used to calculate Buyer's shipping costs",
    notShippableExplain: "This listing is for local pickup in town.",
    multipleListingMode: "Add More",
    successNextTodoLabel: "Add Another Listing",
    allowAccess:
      "It's important to allow camera access so that you can take lots of great photos of things you're selling",
    accessButtonsNo: "Maybe Later",
    mobileFilesTooltip: "Select Photos from your Gallery",
    shoot1Tooltip: "Snap Quick Photos of your Item",
    titleTooltip: "Close the Camera",
    accessButtonsYes: "Allow Access",
    ctaPitch:
      "Your listings automatically receive millions of daily views when we feature them on our publisher sites!",
    learnMoreButton: "Learn More",
    learnMore: "Learn More",
    successHeading: "Listing Published!",
    editSaveNotice:
      "Listing Saved!",
    successPreviewLabel: "View this Listing",
    successEditLabel: "Edit this listing",
    successBackLabel: "Back",
    successMyListings: "My Listings",
    headerSimple: "Simple",
    headerPrecise: "Precise",
    connectCTAHeading: "How should we pay you?",
    connectCTAExplain:
      "Get Top Featured and Most Importantly Paid by Connecting with Stripe Now!",
    successSetupStripe: "Get Your Earnings",
    addFilesLabel: "Select Photos",
    cameraLabel: "Camera",
    postPageTitle: "Post a Listing",
    rotateRightLabel: "Right",
    rotateLeftLabel: "Left",
    productDeletedMessage: "Listing has been deleted",
    imagesNeededErrorMessage: `Please add Photos of your Listing.  Max ${MAX_SELL_IMAGES}.`,
    introHeading: "Please Allow Sellwild",
    introHeading2: "To access your photos and your camera",
    allowPermissionsMsg:
      "Please allow access to the camera so we can start your listing",
    deleteProductLabel: "Delete Listing",
    viewProductLabel: "View Listing",
    buyerProtectionHeading: "Buyer Protection",
    buyerProtectionExplain:
      "Receive your purchase as described or your money back.",
    productMarkedSoldMessage: "Listing has been marked as sold",
    permissionBeginLabel: "Will Do",
    addAngleTooltip: "Click to Edit Photo",
    takeShotLabel: "Start",
    maxPhotosLabel: "Max photos",
    newItemLabel: "Next",
    doneLabel: "Done",
    backLabel: "Back",
    editLabel: "Edit",
    updateLabel: "Save",
    bundleTooltipLabel1: "Open",
    bundleTooltipLabel2: "Reset",
    deleteLabel: "Delete",
    detailsHeading: "Add Details",
    descriptionHeading: "Description",
    deliveryHeading: "Delivery",
    pricingHeading: "Name Your Price (USD)",
    setPriceLabel: "Set Your Price",
    weightLabel: "Weight (lbs)",
    heightLabel: "Height",
    widthLabel: "Width",
    depthLabel: "Depth",
    measurementSystem: "(in)",
    heightErrorMessage: "Height needed",
    widthErrorMessage: "Width needed",
    depthErrorMessage: "Depth needed",
    weightErrorMessage: "Weight needed",

    simpleHeader: "Packaging",
    otherPackagingPlaceholder: "Add other packaging",
    buyerPaysForShipping: "Buyer pre-pays for the Shipping Label",
    smallBox: "Small Box ",
    medBox1: "Medium Box 1",
    medBox2: "Medium Box 2",
    largeBox1: "Large Box",
    largeBox2: "Large Flat Rate Box 2",
    customBox: "Custom Package Dimensions",

    smallBoxDesc: "Jewelry, Electronics, Tickets, Small Items",
    medBox1Desc: "Top-loading. For Shoes, Clothes, Game systems",
    medBox2Desc: "Side-loading. For Laptops, Computers, Gifts",
    largeBox1Desc: "Tools, Large Decor Items, Jackets",
    largeBox2Desc: "For Electronics, Tools..",

    smallFlatRateWidth: "8 5/8",
    smallFlatRateHeight: "5 3/8",
    smallFlatRateDepth: "1 5/8",
    smallFlatRateWidthRounded: 8,
    smallFlatRateHeightRounded: 5,
    smallFlatRateDepthRounded: 1,
    med1FlatRateWidth: "11",
    med1FlatRateHeight: "8 1/2",
    med1FlatRateDepth: "5 1/2",

    med1FlatRateWidthRounded: 11,
    med1FlatRateHeightRounded: 8,
    med1FlatRateDepthRounded: 5,

    med2FlatRateWidth: "13 5/8",
    med2FlatRateHeight: "11 7/8",
    med2FlatRateDepth: "3 3/8",

    med2FlatRateWidthRounded: 13,
    med2FlatRateHeightRounded: 11,
    med2FlatRateDepthRounded: 3,

    // large1FlatRateWidth: "23 11/16",
    // large1FlatRateHeight: "11 3/4",
    // large1FlatRateDepth: "3",

    // large1FlatRateWidthRounded: 24,
    // large1FlatRateHeightRounded: 12,
    // large1FlatRateDepthRounded: 3,

    large1FlatRateWidth: "12",
    large1FlatRateHeight: "12",
    large1FlatRateDepth: "5 1/2",

    large1FlatRateWidthRounded: 12,
    large1FlatRateHeightRounded: 12,
    large1FlatRateDepthRounded: 5,

    addProductTooltip: "Add Listing",
    addMoreImagesTooltip: "Add More Images to this Listing",
    noMoreImagesTooltip: `Max ${MAX_SELL_IMAGES} Images Per Listing`,
    // A pick or drop that goes past the cap keeps what fits and says so.
    // {added} and {total} are filled in where the photos are counted.
    photoLimitSomeAdded: `Added {added} of {total} photos. A listing holds up to ${MAX_SELL_IMAGES}.`,
    photoLimitNoneAdded: `This listing already has ${MAX_SELL_IMAGES} photos, the most it can hold. Delete one to add another.`,
    stripeFee: "Stripe Fee",
    sellwildFee: "Sellwild Fee",
    stripeFeeTooltip: "Stripe fee is 2.9% + 0.30 of sold price",
    sellwildFeeTooltip: "Sellwild fee is 10% of sold price",
    // {rate} is filled from the seller's own fee status, so the tooltip never
    // quotes a rate they do not actually pay.
    sellwildFeeTooltipRate: "Sellwild fee is {rate} of sold price",
    sellwildFeeTooltipReduced: "Your Sellwild fee is {rate} of sold price, down from {baseRate}",
    shipping: "Shipping",
    shippingTooltip: "Shipping is esimated based on your location ",
    // The payment is captured when the seller approves the order, and the
    // destination charge moves their share to Stripe then, before shipping.
    youEarnTooltip: "What reaches your Stripe account when you approve the order. Stripe then pays it out to your bank.",
    youEarn: "You Earn",
    takehome: "Take Home",
    listButton: "List",
    reorderInfo: "Drag to Reorder Photos",
    saveButton: "Save draft",
    deliveryMethod: "Delivery Method",
    whoPaysShiping: "Who will pay for shipping?",
    buyerPays: "The buyer",
    sellerPays: "I'll pay",
    titleLabel: "What are you selling? (Required)",
    descLabel: "Describe your item (Optional)",
    tagsLabel: "Add up to 3 tags",
    categoryLabel: "Category",
    brandLabel: "Brand",
    priceLabel: "Price",
    conditionLabel: "Condition",
    conditionHeading: "Select Item's Condition",
    colorLabel: "Color",
    desktopHeading: "Start by Uploading Photos of Your Listing",
    desktopHeading2: "", //"Add photos for up to 7 products at once!",
    metaDataHeading: "Add a Title",
    saveLabel: "Continue",
    savingLabel: "Saving...",
    finishLabel: "Finish",
    chooseShippingLabel: "Choose Shipping",
    sendingCodeLabel: "Sending code...",
    guestShippingHeading: "Where It Ships From",
    guestCodeSendFailedMessage:
      "We couldn't send your code. Your listing is saved here. Press Finish to try again.",
    guestAddressSaveFailedMessage:
      "You're signed in, but we couldn't save your address. Your listing is saved here. Check the address and press Finish.",
    uploadButtonLabel: "Add Photos",
    desktopIntroHeading: "Pics. Post. Ship. Get Paid",
    desktopIntroButton: "Get Started",
    titleShortErrorMessage: "Give it a title of 3 characters or more",
    descriptionShortErrorMessage:
      "Describe it a little. Color, brand, size, etc",
    categoryInvalidErrorMessage: "Category is required",
    conditionInvalidErrorMessage: "Condition is required",
    priceInvalidErrorMessage: "Set a price of $5 or more",
    // 	postTourSteps: [
    //     {
    //       target: '.step1',
    //       content: 'This is my awesome feature!',
    //     },
    //     {
    //       target: '.step2',
    //       content: 'This another awesome feature!',
    //     }
    // ]
  },
  transaction: {
    orderPageTitle: "Purchase",
    keepShoppingLabel: "Continue Shopping",
    currentStatusHeading: "Current Status",
    confirmShipmentLabel: "Shipped",
    confirmDeliveryLabel: "Delivered",
    boughtByHeading: "Bought by",
    supportButton: "Contact Support",
    printLabelButton: "Print Ship Label",
    // The seller-buys-a-label flow, for orders the buyer paid a flat estimate on
    // because we had no seller address to quote a carrier with at checkout.
    getLabelRatesButton: "Buy a shipping label",
    gettingLabelRatesLabel: "Getting rates...",
    buyLabelRatesHeading: "Choose a service",
    // Sellwild pays for the label, so only services at or under what the buyer
    // paid are offered — or the cheapest one when none is.
    buyLabelExplain: "The buyer paid {paid} toward shipping. Pick a service and Sellwild buys the label.",
    buyLabelOnlyCheapestExplain: "No service costs {paid} or less, so only the cheapest is offered. Sellwild covers the difference.",
    buyLabelButton: "Buy this label",
    buyingLabelLabel: "Buying...",
    labelRatesCancel: "Never mind",
    noSellerAddressHeading: "Add the address you ship from",
    noSellerAddressExplain: "We do not have the address you ship from, so we cannot buy a label for this order. Add it and we can — or ship it yourself and add the tracking number below.",
    noSellerAddressAction: "Add your address",
    labelBoughtMessage: "Label bought. You can print it now.",
    couldNotBuyLabelMessage: "Could not buy the label",
    manualShippingExplain: "This order has no prepaid label. Ship it yourself and add the tracking number so the buyer can follow it.",
    sellwildFeeLabel: "Sellwild Fee",
    youEarnLabel: "You Earn",
    // The coupon row on a sale. A seller's own coupon comes off their share. A
    // platform coupon is paid by Sellwild on sales from 2026-09-25, so it does
    // not; before that the seller funded it like any other.
    discountLabel: "Discount",
    platformDiscountLabel: "Platform Discount",
    platformDiscountPaidLabel: "Platform Discount (paid by Sellwild)",
    shippingLabel: "Shipping Cost",
    shipToBuyerHeading: "Ship to Buyer",
    trackingLabel: "Tracking Number",
    whatsNext: "What's Next...",
    orderNumberLabel: "Order",
    orderDateLabel: "Date",
    chatWithLabel: "Securely Chat",
    verifiedSellerTitle: "Verified Seller",
    sellerTitle: "Seller",
    verifiedBuyerTitle: "Verified Buyer",
    buyerTitle: "Buyer",
    checkoutNowLabel: "Checkout Now",
    transactionHeading: "Sale Details",
    transactionPageTitle: "Sales",
    cancelTransactionLabel: "Cancel Order",
    confirmTransactionLabel: "Approve",
    processingLabel: "Processing...",
    disputeTransactionLabel: "Dispute Order",
    confirmDeliveredLabel: "Confirm Receipt",
    cancelOrderConfirmHeading: "Cancel this order?",
    cancelOrderConfirmExplain: "Cancelling will release the payment hold on your card. The seller will be notified.",
    disputeConfirmHeading: "Open a dispute?",
    disputeConfirmExplain: "Tell us what went wrong. Filing a dispute puts this order on hold and tells the seller and our team, so we can help sort it out.",
    disputeConfirmLabel: "Submit Dispute",
    disputeReasonPlaceholder: "Tell us what went wrong with this order…",
    // The seller's way out after Approve: the same dispute, from the sale page.
    sellerDisputeLabel: "Report a Problem",
    sellerDisputeConfirmHeading: "Report a problem with this sale?",
    sellerDisputeConfirmExplain: "Tell us what went wrong. This puts the sale on hold and tells the buyer and our team, so we can help sort it out.",
    confirmDeliveryConfirmHeading: "Confirm delivery?",
    // Confirming asks for COMPLETED (utils/order-completion.ts). Once an order
    // is complete it can no longer be disputed, so the buyer is told that here,
    // before they press it, and not after.
    confirmDeliveryConfirmExplain: "Only confirm once the item is in your hands and it's what you ordered. This completes the order and tells the seller. After that you can't open a dispute, so check it first.",
    confirmDeliveryConfirmLabel: "Yes, I received it",
    nevermindLabel: "Nevermind",
    transactionSellerStatuses: [
      "Order Pending", // 0
      "Payment Authorized", // 1
      "You Accepted this Order", // 2
      "Out for Delivery", // 3
      // A carrier scan sets DELIVERED; a buyer who confirms goes straight to
      // COMPLETED. So DELIVERED no longer means the buyer confirmed anything.
      "Item Delivered", // 4
      "Sale Complete", // 5
      "Sale Disputed", // 6
      "Sale Canceled", // 7
    ],
    transactionSellerStatusesNoShippo: [
      ``,
      "",
      "",
      "You have Marked Item Shipped or Delivered",
      "",
      "",
      "",
      "",
    ],
    transactionSellerExplanations: [
      "The buyer has started an order but has not completed payment yet.",
      `The buyer has authorized the full amount including shipping. This listing is marked pending to other buyers.`,
      "You have accepted the sale.",
      "You have printed the shipping label and are delivering this item to the carrier.",
      "The item has been delivered. The sale completes when the buyer confirms it, or on its own 3 days after delivery if no dispute is opened.",
      "This sale is complete and now counts in your earnings.",
      "This sale is being disputed.",
      "This sale was canceled.",
    ],
    transactionSellerExplanationsNoShippo: [
      "",
      `The buyer has authorized the full amount. Shipping is arranged separately. This listing is closed to other buyers.`,
      `You have accepted the sale. Ship the item using your preferred carrier and enter the tracking number on this page.`,
      `You have shipped the item. Waiting for the buyer to confirm they received it.`,
      "",
      "",
      "",
      "",
    ],
    transactionSellerNext: [
      "",
      "Approve this Payment",
      "Print Label and Ship It",
      "Wait for Delivery",
      "Wait for the Buyer",
      "",
      "Support Will Follow Up",
      "",
    ],
    transactionSellerNextNoShippo: [
      "",
      "",
      "Ship It and Add Tracking",
      "Wait for the Buyer",
      "",
      "",
      "",
      "",
    ],
    transactionSellerNextExplanations: [
      ``,
      // Capture happens on ACCEPT and checkout is a destination charge, so the
      // seller's share goes to their Stripe account the moment they approve.
      // Nothing waits for delivery. Stripe pays it out on its own schedule.
      `Approving charges the buyer and sends your share to your Stripe account, and closes this item to other buyers. Canceling will reopen the listing and end this sale.`,
      "Please print the prepaid shipping label and drop off the package at the carrier within 3 days.",
      "Waiting for the carrier to deliver the item. After that the buyer can confirm they got it.",
      "The buyer has 3 days from delivery to confirm or open a dispute. If they do neither, the sale completes on its own.",
      "",
      "Sellwild Support will follow up with you via email to discuss next steps.",
      "",
    ],
    // The status line has the same third case as the next-step block below: it
    // must not tell a seller to use their own carrier while the page is
    // offering to buy them a label.
    transactionSellerExplanationsCanBuyLabel: [
      "",
      "",
      "You have accepted the sale. Buy a shipping label below, or ship the item with your own carrier and enter the tracking number on this page.",
      "",
      "",
      "",
      "",
      "",
    ],
    // A third case, between "we bought your label" and "ship it yourself": the
    // order was paid before we had the seller's ship-from address, so no
    // carrier was ever asked — but one can be now. Without this the page told
    // the seller shipping was arranged separately, directly above a button
    // offering to buy them a label.
    transactionSellerNextCanBuyLabel: [
      "",
      "",
      "Buy a Label or Ship It Yourself",
      "Wait for the Buyer",
      "",
      "",
      "",
      "",
    ],
    transactionSellerNextExplanationsCanBuyLabel: [
      ``,
      ``,
      `This order was paid before we had your ship-from address, so no label was bought for it. Get rates and we will buy one — you will see each price against what the buyer paid — or ship it yourself and enter the tracking number below. Once shipped, click Shipped.`,
      "Your share went to your Stripe account when you accepted. The sale completes when the buyer confirms they received it. If you have a problem getting paid, please contact Sellwild Support.",
      "",
      "",
      "",
      "",
    ],
    transactionSellerNextExplanationsNoShippo: [
      ``,
      ``,
      `Shipping is arranged separately. Ship the item using your preferred carrier and enter the tracking number below. Once shipped, click Shipped.`,
      "Your share went to your Stripe account when you accepted. The sale completes when the buyer confirms they received it. If you have a problem getting paid, please contact Sellwild Support.",
      "",
      "",
      "",
      "",
    ],
    transactionBuyerStatuses: [
      `Order Pending`,
      "Payment Authorized",
      "Seller Accepted Your Order",
      "Out for Delivery",
      "Item Delivered",
      "Purchase Complete",
      "Purchase Disputed",
      "Purchase Canceled",
    ],
    transactionBuyerStatusesNoShippo: [
      ``,
      "",
      "",
      "Out for Delivery",
      "Delivery Confirmed",
      "",
      "",
      "",
    ],
    transactionBuyerExplanations: [
      "You have started an order.",
      `Your card has a hold for this amount. You are charged when the seller accepts.`,
      "The seller has accepted your order.",
      "The seller has shipped your item and it is on its way.",
      "Your item was delivered.",
      "This purchase is complete. Enjoy your item!",
      "This purchase is being disputed.",
      "This purchase was canceled.",
    ],
    transactionBuyerExplanationsNoShippo: [
      "",
      ``,
      "",
      "Contact the seller through chat to arrange shipping or pickup.",
      "",
      "",
      "",
      "",
    ],
    transactionBuyerNext: [
      "Complete Payment",
      "Seller Will Approve",
      "Seller Will Ship It",
      "Wait for Delivery",
      // DELIVERED: the carrier scanned it delivered. Confirm Receipt is what
      // completes the order now, and it is on this page.
      "Confirm You Got It",
      "",
      "Support Will Follow Up",
      "",
    ],
    transactionBuyerNextNoShippo: [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    transactionBuyerNextExplanations: [
      "Complete your payment to secure this item. Your purchase is protected.",
      `We've notified the seller of your order. They will approve it within 7 days or it will automatically expire.`,
      "The seller has accepted your order and is preparing your item to ship.",
      "The item is in transit to your address. Please allow 5-10 business days for delivery.",
      "If all is well, press Confirm Receipt. If something is wrong, open a dispute. The order completes on its own 3 days after delivery, and after that it can't be disputed.",
      "Purchase complete.",
      "Sellwild Support will follow up with you via email to discuss next steps.",
      "",
    ],
    transactionBuyerNextExplanationsNoShippo: [
      "",
      ``,
      "The seller has accepted your order. Connect with them through chat to arrange delivery.",
      "The seller has indicated the item was shipped or delivered.",
      "",
      "",
      "",
      "",
    ],
    // CJ Dropshipping — auto-fulfilled, no seller approval step
    transactionBuyerStatusesCJ: [
      "Order Pending",           // 0
      "Order Processing",        // 1 - AUTHORIZED (auto-advances to 2)
      "Order Confirmed",         // 2 - ACCEPTED
      "Shipped",                 // 3 - DELIVERING
      "Item Delivered",          // 4
      "Purchase Complete",       // 5
      "Purchase Disputed",       // 6
      "Purchase Canceled",       // 7
    ],
    transactionBuyerExplanationsCJ: [
      "You have started an order.",
      "Your payment has been authorized and your order is being processed.",
      "Your order has been confirmed and is being prepared for shipment.",
      "Your item has shipped and is on its way to you.",
      "Your item has been delivered.",
      "This purchase is complete. Enjoy your item!",
      "This purchase is being disputed.",
      "This purchase was canceled.",
    ],
    transactionBuyerNextCJ: [
      "Complete Payment",        // 0
      "Order Being Processed",   // 1
      "Preparing to Ship",       // 2
      "Wait for Delivery",       // 3
      "Confirm You Got It",      // 4
      "",                        // 5
      "Support Will Follow Up",  // 6
      "",                        // 7
    ],
    transactionBuyerNextExplanationsCJ: [
      "Complete your payment to secure this item. Your purchase is protected.",
      "Your order is being processed. You'll receive tracking info by email once it ships.",
      "Your order is confirmed and being prepared for shipment. You'll receive tracking info soon.",
      "Your item is in transit. Please allow 5-10 business days for delivery.",
      "If all is well, press Confirm Receipt. If something is wrong, open a dispute. The order completes on its own 3 days after delivery, and after that it can't be disputed.",
      "Purchase complete.",
      "Sellwild Support will follow up with you via email to discuss next steps.",
      "",
    ],
  },
  // Asked of a signed-in member whose account has no email — a phone-only
  // signup, 27.7% of registrations. One set of controls, three framings: the
  // reason to hand over an address differs by where you are standing.
  emailCapture: {
    heading: "Add an email to your account",
    subheading:
      "You signed up with a phone number, so we don't have an email address for you yet. Receipts, sale alerts and order updates all go there.",
    checkoutHeading: "Where should we send your receipt?",
    checkoutSubheading:
      "You signed up with a phone number, so we don't have an email address for you yet.",
    sellHeading: "Add an email before your first sale",
    sellSubheading:
      "Sale alerts, payout setup and shipping updates all go to email, and we don't have one for you yet.",
    emailLabel: "Email address",
    sendCode: "Send code",
    sending: "Sending...",
    codeSubheading: "Enter the code we sent to",
    codeLabel: "6-digit code",
    verify: "Verify",
    verifying: "Verifying...",
    editEmail: "Use a different address",
    verified: "Email confirmed —",
    invalidEmail: "That doesn't look like an email address.",
    invalidCode: "That code isn't right, or it has expired.",
    tooManyCodes: "Too many wrong codes. Wait 15 minutes, then try the newest code.",
    sendFailed: "We couldn't send the code. Try again in a moment.",
    networkError: "Something went wrong reaching us. Check your connection and try again.",
  },
  nameCapture: {
    heading: "Add your name",
    subheading:
      "Buyers see your first name on your listings, and shipping labels need one. Your last name is optional.",
    sellHeading: "What name should buyers see?",
    sellSubheading:
      "It shows on your listings and your store. Just a first name is fine.",
    nameLabel: "Your name",
    save: "Save",
    saving: "Saving...",
    saved: "Thanks,",
    nameRequired: "Enter the name you'd like buyers to see.",
    saveFailed: "We couldn't save your name. Try again in a moment.",
    networkError: "Something went wrong reaching us. Check your connection and try again.",
  },
  /** components/contact-capture: the name + email popup before a first chat or a post. */
  contactCapture: {
    chatHeading: "Before you send",
    chatExplain: "Add your name so the seller knows who's writing, and an email so you hear back when you're away.",
    sellHeading: "Before you post",
    sellExplain: "Buyers see your first name on your listing. Sale alerts and payouts go to your email.",
    nameHeading: "Your name",
    nameSubheading: "Just a first name is fine.",
    emailHeading: "Your email",
    emailSubheading: "We'll send a 6-digit code to check it.",
    notNowLabel: "Not now",
    continueLabel: "Continue",
  },
  checkout: {
    pageTitle: "Checkout",
    viewOrderLabel: "View Order",
    salesTaxLabel: "Sales tax",
    // Shown while a guest's new account is being caught up with the webhook.
    claimingLabel: "Opening your order...",
    closeAddCardLabel: "Cancel",
    shippingHeader: "My Addresses",
    estShipLabel: "Listed",
    shipByLabel: "Listed By",
    addAddressHeading: "Add New Address",
    streetSearchPlaceholder: "Search Street Address",
    townSearchPlaceholder: "Search Towns",
    getProductPath: "/product",
    invalidListingNotification:
      "This appears to be an invalid Listing now.  Sorry about that",
    orderSuccessDisclaimer:
      'This is a "Request to Buy." An authorization charge for the full amount will be held on your card until the seller accepts or declines.',
    noDimensionsNotification: "No dimensions set for this Listing",
    notSetupStripeErrorMsg: "Sorry, Seller has not setup their Stripe Account",
    noGPSError: "This device's GPS is unavailable",
    itemSoldErrorMsg: "Sorry, Item already sold",
    yourOwnListingNotification: "This is Your Listing",
    orderHeading: "Order Details",
    priceLabel: "Listing Price",
    // An automatic coupon's rows, worded as the product page words them.
    originalLabel: "Original",
    discountLabel: "Discount",
    salePriceLabel: "Sale Price",
    orderSuccessMessage: "Order Placed",
    orderEmailedMessage: "We have e-mailed you a receipt for this order.",
    shippingMethodHeading: "Shipping Method",
    shippingPriceHeading: "Shipping",
    estimateCalculating: "Calculating...",
    savingLabel: "Saving...",
    notShippableHeading: "Pickup only",
    notShippableExplain:
      "Your card is only authorized for now. You're charged when the seller accepts. You and the seller will use Secure Chat to arrange shipping or pickup. Once you have the item, confirm receipt on your order.",
    estimateTBD: "Enter Shipping Address",
    checkoutFAQHeading: "Frequently Asked Questions",
    estimateNA: "No Shipping",
    estimateLoading: "Loading...",
    subTotalLabel: "Subtotal",
    totalLabel: "Total",
    totalHeldLabel: "Total Held",
    maxBuyersErrorMsg: "Sorry, this listing is already Pending a Sale",
    paymentCancelledErrorMsg: "Payment in cancelled state",
    alreadyBoughtErrorMsg: "You already checked out on this item",
    completeCheckoutButton: "Process Order",
    // Says the charge is an authorization first, because that is what a buyer
    // needs at the Pay button. The save clause stays: the element's own card
    // mandate is suppressed (`terms: { card: "never" }`), and Stripe requires
    // whoever suppresses it to get the buyer's consent to keep the card.
    // Capture happens on the seller's ACCEPT (transactions/[id]/status.ts),
    // not on delivery, so that is what it says.
    // Under the classic (A) widget's Pay button. It stands in for Stripe's own
    // card mandate, which that widget hides, so it says the card is kept.
    checkoutAuthorizationNote:
      "This authorizes the amount. You're not charged until the seller accepts your order. Your card is saved to your Sellwild account for next time.",
    checkoutCardConsent:
      "This authorizes the amount. You're not charged until the seller accepts your order. Your card is saved to My Wallet for next time.",
    // A guest's card is NOT saved (owner, 2026-09-30): a guest never asked for
    // an account, so the note says only what pressing Pay does. The 7-day hold
    // is the manual-capture authorization, which saving never affected.
    guestCheckoutConsent:
      "This authorizes the amount. You're not charged until the seller accepts your order.",
    requiresConfirmationMsg: "Requires Confirmation",
    // Pay was pressed with no saved card selected.
    choosePaymentMethodMsg: "Choose a card to pay with, or add a new one.",
    // A saved card the bank wants to confirm (3D Secure) or that did not go through.
    savedCardNotCompletedMsg: "Your bank needs to confirm this card. Add it again with Add a card and press Pay.",
    completeingLabel: "Finishing Up...",
    paymentHeading: "Select Payment Method",
    taxLabel: "Tax",
    shipToHeading: "Ship To:",
    loginButton: "Login",
    stripeFeeLabel: "Stripe",
    stripeFeeTooltip: "Stripe Credit Card Fee (2.9% + $0.30)",
    alreadyHaveAccount: "Already have a Sellwild Account?",
    selectShippingLabel: "Select shipping charges",
    totalDueLabel: "Total Due",
    cityTownLabel: "Town or City",
    confirmAgreeButton: "Proceed to Payment",
    confirmShippingButton: "Proceed to Payment",
    confirmingLabel: "Confirming...",
    addressDrawerHeading: "Address Book",
    emailLabel: "Email Address",
    addressHeading: "Address",
    addressDisclaimer:
      "We never share or sell your address.  The seller gets it as a shipping label.",
    countryLabel: "Country",
    saveAddressButtonLabel: "Save Address",
    saveCityButtonLabel: "Set Location",
    geoLocationButton: "Use My GPS",
    geoPositionError:
      "Error getting your Geo-Position. Please enter City, State or Zip.",
    enterDetails: "Add a Shipping Address",
    shippingDetailsButton: "Add shipping details",
    changeShippingAddress: "Change Shipping Address",
    shippingAddressHeading: "Ship to",
    addressLabel: "Address",
    addressLine2Label: "Address Line 2",
    cityLabel: "City",
    zipLabel: "Zip Code",
    regionLabel: "Region",
    postalCodeLabel: "Postal Code",
    stateLabel: "State",
    addressesHeading: "Recent Addresses",
    addressInvalidErrorMessage: "Please search for your shipping address",
    // Shown on the guest address field when the buyer typed an address but never
    // picked one, which used to fail the continue button in silence.
    addressMissingErrorMessage: "Pick your address from the suggestions",
    cityInvalidErrorMessage: "City please",
    stateInvalidErrorMessage: "State please",
    regionInvalidErrorMessage: "Region please",
    zipInvalidErrorMessage: "Zip Code please",
    postalInvalidErrorMessage: "Postal Code please",
    countryInvalidErrorMessage: "Country please",
  },
  admin: {
    pageTitle: "Admin Dashboard",
    navButtons: [
      {
        label: "Inbox",
        href: "/dash/inbox",
        icon: "Inbox",
      },
      {
        label: "Numbers",
        href: "/dash/numbers",
        icon: "BarChart3",
      },
      {
        label: "Partners",
        href: "/dash/partners",
        icon: "FileText",
      },
      {
        label: "Widget Feed",
        href: "/dash/widget-feed",
        icon: "Newspaper",
      },
      {
        label: "CJs Inventory",
        href: "/dash/inventory",
        icon: "Warehouse",
      },
      {
        label: "Events",
        href: "/dash/events",
        icon: "Activity",
      },
      {
        label: "Errors",
        href: "/dash/errors",
        icon: "AlertTriangle",
      },
      {
        label: "Emails",
        href: "/dash/emails",
        icon: "Mail",
      },
      {
        label: "Funnels",
        href: "/dash/funnels",
        icon: "Filter",
      },
      {
        label: "Search",
        href: "/dash/search",
        icon: "Search",
      },
      {
        label: "Sellers",
        href: "/dash/sellers",
        icon: "Users",
      },
      {
        label: "Orders",
        href: "/dash/orders",
        icon: "Package",
      },
      {
        label: "Chats",
        href: "/dash/chats",
        icon: "MessageSquare",
      },
      {
        // The moderation queue. FLAGGED_LISTINGS and REPORTED_USERS had been
        // collecting for years with no reader — the admin email at filing time
        // was the only surface either ever had.
        label: "Reports",
        href: "/dash/reports",
        icon: "Flag",
      },
      {
        label: "Tags",
        href: "/dash/tags",
        icon: "MessageSquare",
      },
      {
        label: "Coupons",
        href: "/dash/coupons",
        icon: "Ticket",
      },
      {
        // Seller commission rules. The page has existed since the fee-tier work
        // shipped but was never linked here, so the only way in was typing the
        // URL — which is why it read as missing.
        label: "Seller Fees",
        href: "/dash/seller-fees",
        icon: "Percent",
      },
      {
        label: "Smart Pricing",
        href: "/dash/smart-pricing",
        icon: "TrendingDown",
      },
      {
        label: "Categories",
        href: "/dash/categories",
        icon: "FolderTree",
      },
      {
        label: "UI Tests",
        href: "/dash/ui-tests",
        icon: "Split",
      },
      {
        label: "Tests",
        href: "/dash/tests",
        icon: "FlaskConical",
      },
    ],
    categorize: {
      pageTitle: "Numbers",
    },
  },
  account: {
    // Close My Account: the one way to leave, a soft close (pages/api/user/deactivate.ts).
    closeAccountLabel: "Close My Account",
    closeAccountExplain:
      "Closing hides your profile and listings, signs you out and frees your username. Signing in again starts a new account. To get this one back, contact support. We'll send a code to your email (or phone) to confirm it's you.",
    closeAccountHeading: "We're Sorry to See You Go",
    closeAccountSendCodeLabel: "Send Code",
    keepAccountLabel: "Keep My Account",
    accountClosedMsg: "Your account has been closed.",
    bank: {
      pageTitle: "ACH direct Debit",
      formHeading: "Account details",
      accountNameLabel: "Account Holder Full Name",
      bankNameLabel: "Bank Name",
      accountNumberLabel: "Account Number",
      routingNumberLabel: "Routing Number",
      saveButtonLabel: "Save Account",
    },
    addresses: {
      shipsFromAddress: "Shipping From",
      confirmRemovalHeading: "Remove Address?",
      confirmRemovalExplain:
        "Are you sure you want to delete this address from your Sellwild Account?",
      confirmRemovalLabel: "Remove",
      backToAddressList: "View Address List",
      removeSuccessMsg: "Address Deleted",
      emptyConfirmRemovalExplain: "",
      pageTitle: "Address Book",
      addAddressHeading: "Add Shipping Address",
      addressesHeading: "My Addresses",
      setDefaultSuccessMsg: "Default Shipping Address Updated",
      addressCannotBeDeletedMsg: "Due to Active Use, Address Cannot Be Removed",
      cancelButtonLabel: "Cancel",
      invalidFromAddressNotification:
        "Can't calculate shipping cost. Seller hasn't setup an Address.",
    },
    shipping: {
      pageTitle: "Shipping",
      labelFormatHeading: "Label Format",
      labelFormatExplain:
        "Choose the paper size your printer uses. Every shipping label you buy for a sale comes out in this format.",
      labelFormatLabel: "Label Format",
      saveButtonLabel: "Save",
      savingLabel: "Saving...",
      saveSuccessMsg: "Shipping settings saved",
      saveErrorMsg: "We couldn't save your shipping settings. Try again in a moment.",
      addressesHeading: "Where you ship from",
      addressesExplain:
        "Sales ship from your default address. Add or change it in your address book.",
      addressesLinkLabel: "Manage addresses",
      packagingHeading: "Default packaging",
      packagingExplain:
        "New listings start with this USPS packaging selected, so buyers see its exact rate. You can still change it on any listing.",
      packagingLabel: "Ship in",
      packagingNoneOption: "No default (enter a size on each listing)",
      applyToLiveDecline: "Not now",
      applyToLiveApplying: "Updating...",
      applyToLiveErrorMsg: "We couldn't update your listings. Nothing was changed.",
    },
    faqSellerTitle: "Seller FAQs",
    // Rendered by components/faq.tsx. An answer is one paragraph, or a list of
    // blocks: a string is a paragraph, { points } a bulleted list and { steps }
    // a numbered one.
    faqSellerContent: [
      {
        question: "How much does it cost to sell?",
        answer: [
          "Listing is free. When an item sells, Sellwild keeps 10% of the item price, up to $500 a sale.",
          {
            points: [
              "No listing fees, and no limit on how many items you list.",
              "The 10% is never taken from shipping or sales tax.",
              "You pay no card fees. The buyer covers those at checkout.",
            ],
          },
        ],
      },
      {
        question: "How do I get paid?",
        answer: [
          {
            steps: [
              "Set up payouts with Stripe under Account > Wallet. Until you do, buyers can message you but can't buy.",
              "A buyer orders your item and you accept the order.",
              "Accepting charges the buyer's card, and your share goes to your Stripe account.",
              "Stripe sends it to your bank on its usual payout schedule.",
            ],
          },
          "What you earned on each sale is under Account > Sales.",
        ],
      },
      {
        question: "How long do I have to accept an order?",
        answer:
          "7 days. We email you a reminder after 1 day and again on day 6. If you don't accept in time, the order cancels and your item goes back on sale.",
      },
      {
        question: "What happens after I accept an order?",
        answer: [
          {
            steps: [
              "We buy a USPS shipping label for the order.",
              "Print the label, pack the item and drop it off with USPS.",
              "The buyer gets the tracking number.",
              "The sale is complete when the buyer confirms they got it, or 3 days after delivery if they don't open a dispute.",
            ],
          },
        ],
      },
      {
        question: "Can I cancel an order?",
        answer:
          "Yes, before you accept it. Open the order under Account > Sales and press Cancel Order. The buyer isn't charged. Once you've accepted, press Report a Problem on the order instead.",
      },
      {
        question: "Who pays for shipping?",
        answer:
          "The buyer. They pick a USPS rate at checkout and pay it with the item. That money buys the label, so you never pay for it.",
      },
      {
        question: "What box should I use?",
        answer: [
          "Any sturdy box or padded mailer works. On your listing, pick the USPS packaging or enter the box size and weight, so the buyer sees the real rate.",
          "Using a USPS Flat Rate box? The post office gives those away free, at the counter or on usps.com.",
          "Set a default box under Account > Shipping and new listings start with it.",
        ],
      },
      {
        question: "Can I sell something too big to ship?",
        answer:
          "Yes. Choose Local Pickup Only when you list it. Buyers then contact you to set up the sale and pickup instead of paying online.",
      },
      {
        question: "Can I ship outside the US?",
        answer: "No. Sellwild shipping labels only work within the United States.",
      },
      {
        question: "How should I price my item?",
        answer: [
          "Search Sellwild for the same item and see what it sells for. Then:",
          {
            points: [
              "A little under that sells fast.",
              "A little over earns more, but takes longer.",
              "Go lower if yours shows more wear than most.",
            ],
          },
        ],
      },
      {
        question: "What can I sell?",
        answer: [
          "Almost anything you own: clothes, electronics, home goods, jewelry, sporting goods, art, collectibles, vehicles and more.",
          "These aren't allowed:",
          { points: PROHIBITED_ITEMS.map((rule) => `${rule.name}. ${rule.examples}`) },
          { link: { href: "/prohibited-items", label: "See the full rules" } },
        ],
      },
      {
        question: "Do I need an account to sell?",
        answer:
          "Not to start. Fill in your listing first. When you're ready, add your name, email and address, and we email you a code. Enter the code and your listing goes live.",
      },
      {
        question: "I sell on Vendoo. Why can't I see my listings?",
        answer: [
          "You're signed in with a different email than your Vendoo account uses.",
          "Vendoo links your listings to the Sellwild account with your Vendoo email. Signing in any other way, like Google or Facebook on another address, opens a new, empty account.",
          "Sign out, then sign in with your Vendoo email.",
        ],
      },
      {
        question: "How does Vendoo work with Sellwild?",
        answer: [
          {
            points: [
              "Items you post to Sellwild from Vendoo show up under your Sellwild account.",
              "When one sells here, Vendoo is told as soon as you accept the order.",
              "Changes you make in Vendoo after posting don't carry over. Make them here too.",
            ],
          },
        ],
      },
      {
        question: "Do I owe taxes on what I sell?",
        answer:
          "You may owe income tax on your sales. The rules depend on where you live and how much you sell, so ask a tax professional.",
      },
      {
        question: "What if a buyer opens a dispute?",
        answer:
          "The order is paused while our team looks into it. We may ask you both for photos or tracking. If the buyer is refunded, the refund comes out of that sale. Most problems get sorted out in chat before it gets that far.",
      },
      {
        question: "How does Sellwild protect sellers?",
        answer: [
          {
            points: [
              "The buyer pays before you ship. Their card is charged when you accept the order.",
              "Payments go through Stripe. We never see card numbers.",
              "Every label is tracked, so delivery is on record.",
            ],
          },
        ],
      },
    ],
    faqBuyerTitle: "Buyer FAQs",
    faqBuyerContent: [
      {
        question: "How does buying work?",
        answer: [
          {
            steps: [
              "Press Buy Now on a listing and check out.",
              "The seller accepts your order. That's when your card is charged.",
              "The seller ships it and we email you the tracking.",
              "When it arrives, open the order and press Confirm Receipt.",
            ],
          },
        ],
      },
      {
        question: "When is my card charged?",
        answer:
          "When the seller accepts your order. Until then the amount is only on hold. If the seller doesn't accept within 7 days, the order cancels and the hold drops off.",
      },
      {
        question: "Why doesn't a listing have Buy Now?",
        answer:
          "The seller hasn't set up payouts yet, or the item is local pickup only. Press Contact Seller to message them.",
      },
      {
        question: "Do I need an account to buy?",
        answer:
          "No. You can check out as a guest. With an account, all your orders and chats are in one place.",
      },
      {
        question: "What will I pay?",
        answer: [
          "You see the full total before you pay:",
          {
            points: [
              "The item price",
              "Shipping, from the USPS rates for your address",
              "A card processing fee",
              "Sales tax, where it applies",
            ],
          },
          "Sellwild shipping covers US addresses only.",
        ],
      },
      {
        question: "How can I pay?",
        answer:
          "By credit or debit card. You may also see Apple Pay, Google Pay or Link, depending on your device. Payments go through Stripe, so Sellwild never sees your card number.",
      },
      {
        question: "Where is my order?",
        answer:
          "Open it under Account > Purchases. The tracking number shows there once the seller ships. We also email you when the seller accepts, ships and when it's delivered.",
      },
      {
        question: "Can I cancel my order?",
        answer:
          "Yes, until the seller accepts it. Open the order under Account > Purchases and press Cancel Order. Your card isn't charged.",
      },
      {
        question: "What is the Buyer Guarantee?",
        answer: [
          "You get a full refund when an order you bought and shipped through Sellwild:",
          {
            points: [
              "Never arrives",
              "Arrives damaged",
              "Is the wrong item, or is missing pieces",
              "Is very different from the listing, like the wrong color or material",
            ],
          },
          "If the seller doesn't ship your item, open the order under Account > Purchases and press Dispute Order. If it never shipped, we refund you to your original payment method.",
        ],
      },
      {
        question: "What isn't covered?",
        answer: [
          {
            points: [
              "Items that don't fit",
              "Items you just don't like",
              "Items that aren't allowed on Sellwild",
              "Anything you paid for outside Sellwild",
            ],
          },
        ],
      },
      {
        question: "How do I get a refund?",
        answer: [
          {
            steps: [
              "Message the seller from the listing. Most problems get fixed here.",
              "If that doesn't work, open the order under Account > Purchases and press Dispute Order.",
              "Our team reviews it. We may ask for photos of the item.",
            ],
          },
          "Open the dispute within 3 days of delivery. After that the order completes and can't be disputed. You can always email support@sellwild.com.",
        ],
      },
      {
        question: "Will asking for a refund hurt the seller?",
        answer:
          "Not for an honest problem. We look at every request and aim for a fair result for both of you.",
      },
      {
        question: "How do I message the seller?",
        answer:
          "Use the chat button on the listing. All your chats are under Account > Chats.",
      },
    ],
    manageDataHeading: "My User Data",
    manageDataExplain:
      "Let's be clear about what data we keep. It's all presented on this page. That's it.",
    manageDataExplain2:
      "We never keep any financial information. That's all handled by our partner",
    addAddress: "Add Shipping Address",
    viewAddresses: "Address Book",
    readPrivacyPolicy: "Read Privacy Policy",
    profile: {
      editProfileHeading: "Edit Your Profile",
      saveButtonLabel: "Save Profile",
      // Shown to accounts that signed up with a phone number and never added an
      // address. Phrased around what they lose rather than as a scolding, since
      // the missing step was ours to drop, not theirs to skip.
      missingEmailHeading: "Add an email address",
      missingEmailExplain:
        "Your account doesn't have one yet, so order confirmations, receipts and shipping updates have nowhere to go. Enter an email below and we'll send a code to verify it.",
    },
    wallet: {
      // The wallet is split into the two jobs it does: getting paid as a
      // seller, and paying as a buyer. Status copy for the payout card is
      // derived per-state in utils/stripe-requirements.ts, not here.
      gettingPaidHeading: "Getting paid",
      payingHeading: "Paying for things",
      payingNote: "Cards you've saved for checkout.",
      earningsLabel: "My Earnings",
      connectHeading: "Connect with Stripe",
      loadingConnectLabel: "Loading...",
      poweredByLabel: "Powered By",
      moreInfoNeeded:
        "Stripe needs a little more information before you're connected",
      confirmRemovalHeading: "Delete?",
      confirmRemovalExplain:
        "Are you sure you want to delete this payment method from your Sellwild Account?",
      confirmRemovalLabel: "Delete Card",
      removeSuccessMsg: "Card deleted from Stripe Successfully",
      addCardSuccessMsg: "Payment method successfully added to your account!",
      cancelButtonLabel: "Cancel",
      wantToSell: "Connect with Stripe to get Paid",
      saveCardButtonLabel: "Save Payment Method",
      saveCardConsent:
        "By saving this card, you allow Sellwild to charge it for purchases you make later. You can remove it any time from this page.",
      setupStripeButtonLabel: "Setup Stripe",
      setupStripeButtonLabel2: "Complete Setup",
      onboardedSuccess: "Stripe is Connected",
      yourCards: "Saved cards",
      noCards: "No payment methods",
      loadingPaymentMethods: "Loading Payment Methods",
      shippingBeforePayment: "Confirm Shipping First",
      addCardLabel: "Add Payment Method",
      contactingStripeLabel: "Loading Stripe...",
      expiresLabel: "Expires",
      mobileWalletsHeading: "Mobile Wallets",
      payLaterHeading: "Buy now, pay later",
      bankDebitHeading: "Bank Account",
      directDebitLabel: "ACH Direct Debit",
    },
    toggleDarkModeLabel: "Try Dark Mode",
    darkModeOnLabel: "Dark Mode On",
    gdprConsentTextShort1: "We use cookies and other tracking technologies",
    gdprConsentTextLong:
      "to assist with navigation, improve our products and services, assist with our marketing efforts, and provide content from third parties",
    gdprConsentTextShort2: "in accordance with our ",
    privacyPageText,
    printShippingLabel: "Print Label",
    printPageTitle: "Print Label",
    usernameEmptyErrorMessage: "Username cannot be empty",
    usernameInvalidErrorMessage: "Username is invalid",
    editListingPageTitle: "Edit Listing",
    editButtonLabel: "Edit",
    manageButtonLabel: "Manage",
    relistButtonLabel: "Relist",
    relistingLabel: "Relisting...",
    relistSuccessNotice: "Your listing is live again.",
    relistErrorNotice: "We couldn't relist that. Try again in a moment.",
    chatButtonLabel: "Chat",
    editUserSuccessMsg: "Successfully Saved Your Profile",
    accountPageTitle: "My Account",
    profilePageTitle: "Profile",
    accountPageGreeting: "Hello, ",
    listingsPageTitle: "My Listings",
    listingsPerPageLabel: "Show",
    listingsPerPageSuffix: "per page",
    listingsJumpLabel: "Jump to page",
    listingsJumpOf: "of",
    listingsJumpButton: "Go",
    listingsCountSingular: "listing",
    listingsCountPlural: "listings",
    listingsWindowLimitNotice:
      "Only the first 10,000 listings can be paged through. Search to reach the rest.",
    headerCurrent: "Current",
    headerPrevious: "Previous",
    chatsPageTitle: "My Chats",
    ordersPageTitle: "My Purchases",
    transactionsPageTitle: "My Sales",
    walletPageTitle: "My Wallet",
    shippingPageTitle: "Shipping",
    wishlistPageTitle: "Wishlist",
    chatHeaderByListing: "Chats by Listing",
    chatHeaderByUser: "Chats by User",
    noWatchesCTAHeading: "You Haven't Hearted Anything Yet",
    noWatchesCTAExplain:
      "Click the heart on any product listing to add it to your Wishlist",
    noWatchesCTAButton: "Browse Marketplace",
    noChatsCTAHeading: "You Have No Chats",
    chatsLoadFailedHeading: "Your Chats Didn't Load",
    chatsLoadFailedExplain: "Something went wrong on our end. Your conversations are safe.",
    chatsLoadFailedButton: "Try Again",
    loadMoreChatsButton: "Load More Conversations",
    loadingMoreChatsButton: "Loading...",
    noChatsCTAExplain: "Message a seller if you're interested in their listing",
    noChatsCTAButton: "Browse Marketplace",
    noCurrentPurchasesCTAHeading: "No Purchases",
    noCurrentPurchasesCTAExplain: "Nothing here yet.",
    noCurrentPurchasesCTAButton: "Goto Wishlist",
    noCurrentPurchasesNoWishlistCTAHeading: "No Purchases",
    noCurrentPurchasesNoWishlistCTAExplain: "Nothing here yet.",
    noCurrentPurchasesNoWishlistCTAButton: "Browse Marketplace",
    listLoadFailedHeading: "We couldn't load this",
    listLoadFailedExplain:
      "Something went wrong on our end. Your listings are safe — try again in a moment.",
    listLoadFailedButton: "Try again",
    noListingsCTAHeading: "No Listings Yet",
    noListingsCTAExplain: "Post your first item and it will show up here.",
    noListingsCTAButton: "Post a Listing",
    // A Vendoo seller who signs in here with a different address gets a fresh,
    // empty account, so the empty page is where they find out.
    vendooEmailCalloutHeading: "Vendoo Seller?",
    vendooEmailCalloutExplain:
      "Make sure you log in to Sellwild with the same email address you used for Vendoo.",
    // Sales lists paid orders, never listings, so it cannot promise a new
    // listing "shows up here". It also shows for sellers whose listings are
    // all archived, so it cannot say "first item" either.
    noListingsSalesCTAHeading: "No Sales Yet",
    noListingsSalesCTAExplain:
      "List an item. When a buyer pays for it, the order shows up here.",
    noSalesNoConnectCTAHeading: "No Sales Yet",
    noSalesNoConnectCTAExplain:
      "We can't make your items available for sale without a connected Stripe account",
    noSalesNoConnectCTAButton: "Connect Stripe",
    yesListingsNoSalesCTAHeading: "No Sales Yet",
    yesListingsNoSalesCTAExplain:
      "When a buyer pays for one of your listings, the order shows up here.",
    yesListingsNoSalesCTAButton: "Manage listings",
    faqsPageTitle: "FAQ's",
    messagesLabel: "Interested",
    contactPageTitle: "Customer Service",
    consentButtonLabel: "Acknowledged",
    privacyPageTitle: "Privacy Policy and Legal Terms of Service",
    viewListingLabel: "View Listing",
    profileDetailLabel: "Profile Settings",
    navButtons: [
      {
        icon: "/images/svg/storefront.svg",
        label: "My Listings",
        href: "/account/my-listings",
      },
      {
        icon: "/images/svg/privacy-shield.svg",
        label: "Sales",
        href: "/account/sales",
      },
      {
        icon: "/images/svg/coupon-tag.svg",
        label: "Discounts",
        href: "/account/discounts",
      },
      {
        icon: "/images/svg/shipbox.svg",
        label: "Purchases",
        href: "/account/purchases",
      },
      {
        icon: "/images/svg/heart-white.svg",
        label: "Wishlist",
        href: "/account/wishlist",
      },
      {
        icon: "/images/svg/wallet.svg",
        label: "Wallet",
        href: "/account/wallet",
      },
      {
        icon: "/images/svg/chat-white.svg",
        label: "Chats",
        href: "/account/chats",
      },
      {
        icon: "/images/svg/home-white.svg",
        label: "Addresses",
        href: "/account/addresses",
      },
      {
        icon: "/images/svg/mailbox.svg",
        label: "Shipping",
        href: "/account/shipping",
      },
      {
        icon: "/images/svg/faq-bubble.svg",
        label: "Notifications",
        href: "/account/notifications",
      },
      {
        icon: "/images/svg/contact-cust-svc.svg",
        label: "Customer Service",
        href: "/guides",
      },
      {
        icon: "/images/svg/logout.svg",
        label: "Logout",
        href: "/logout",
      },
    ],
  },
  swTV: {
    pageTitle: "SWTV",
  },
  domains: {
    dev: "https://dev.sellwild.com",
    prod: "https://sellwild.com",
    stg: "https://new.sellwild.com",
  },
};
